import { useEffect } from "react";
import { Calendar, ArrowRight } from "@phosphor-icons/react";
import { trackWhatsAppClick } from "@/lib/track";

const WHATSAPP_URL =
  "https://wa.me/919819998036?text=" +
  encodeURIComponent(
    "Hi Venkataramanan, I'd like to book a free 15-minute discovery call to discuss "
  );

export default function DiscoveryCallBar() {
  useEffect(() => {
    document.documentElement.classList.add("has-discovery-bar");
    // Clear any old dismiss state from prior versions
    sessionStorage.removeItem("gor_top_bar_dismissed");
    return () => {
      document.documentElement.classList.remove("has-discovery-bar");
    };
  }, []);

  return (
    <div
      data-testid="discovery-call-bar"
      className="fixed top-0 inset-x-0 z-50 bg-[#C6A87C] text-navy"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-11 flex items-center justify-center sm:justify-between gap-4">
        <a
          data-testid="discovery-call-link"
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackWhatsAppClick("discovery_bar")}
          className="flex items-center gap-2 text-xs sm:text-sm font-semibold tracking-wide hover:text-white transition-colors"
        >
          <Calendar size={14} weight="bold" />
          <span className="hidden sm:inline">
            Book a free 15-minute demo to discuss your requirements
          </span>
          <span className="sm:hidden">Free 15-min demo</span>
          <span className="inline-flex items-center gap-1 font-bold underline underline-offset-2">
            on WhatsApp <ArrowRight size={12} weight="bold" />
          </span>
        </a>
      </div>
    </div>
  );
}
